<template>
  <v-form ref="form">

    <h3 v-if="schema.title">{{ schema.title }}<small>{{ schema.description }}</small></h3>

    <form-schema-field-collection
      @input="handleInput"
      :value="internalValue"
      :schema="schema.properties"
      :required-keys="schema.required"
      :disabled="disabled"
    ></form-schema-field-collection>

    <v-layout v-if="!noSubmit">
      <v-spacer></v-spacer>
      <v-btn @click="submit" color="blue-grey" dark>Submit</v-btn>
      <v-btn @click="reset">Reset</v-btn>
    </v-layout>

  </v-form>
</template>

<script>
import FormSchemaFieldCollection from './FormSchemaFieldCollection'

export default {
  name: 'form-schema',

  components: {
    'form-schema-field-collection': FormSchemaFieldCollection
  },

  props: ['schema', 'value', 'noSubmit', 'disabled'],

  data: function () {
    return {
      backupValue: Object.assign({}, this.value),
      internalValue: Object.assign({}, this.value)
    }
  },

  watch: {
    value (newValue, oldValue) {
      if (newValue == null) {
        this.resetDefault()
      } else {
        this.internalValue = Object.assign({}, newValue)
      }
    }
  },

  methods: {

    getForm () {
      return this.$refs.form
    },

    reset () {
      this.internalValue = Object.assign({}, this.backupValue)
      let f = this.getForm()
      if (f) {
        f.reset()
      }
    },

    submit () {
      let f = this.getForm()
      if (f.validate()) {
        this.$emit('submit')
      }
    },

    handleInput (ev) {
      this.internalValue = Object.assign({}, ev)
      this.$emit('input', this.internalValue)
    }

  }
}
</script>
